import { Box, Typography } from "@mui/material";
import { useShallow } from "zustand/react/shallow";

import styles from "../../../../../assets/styles/componentStyles/organizationTeamsStyles/teams.module.scss";

import GroupIcon from '@mui/icons-material/Group';

import { useOrganizationTeamsStore } from "../../../../../store/organizationTeamsStore";
import { thousandSeparator } from "../../../../../utils/constants";

const TeamsHeader = () => {
    
    const { organizationTeamsData } = useOrganizationTeamsStore(
        useShallow((state) => ({
            organizationTeamsData: state.organizationTeamsData,
        }))
    );

    const totalTeams = organizationTeamsData?.length ?? 0;

    return (
        <Box className={styles.teamsHeaderWrapper}>
            <Box className={styles.totalTeamsCard}>

                <Box className={styles.totalTeamsCardContent}>
                    <Typography className={styles.totalTeamsCardLabel}>
                        Total Teams
                    </Typography>

                    <Typography className={styles.totalTeamsCardCount}>
                        {thousandSeparator(totalTeams)}
                    </Typography>
                </Box>

                <Box className={styles.totalTeamsCardIcon}>
                    <GroupIcon fontSize="large" />
                </Box>

            </Box>
        </Box>
    );
};

export default TeamsHeader;
